<template>
  <div
    class="modal fade mt-5"
    id="traineesModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="traineesModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content text-left">
          <div class="modal-header">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div
            class="row p-4 align-items-stretch no-gutters"
            v-if="isModalShowing"
          >
            <div class="col-12 d-flex flex-column">
              <TraineeForm :title="$t('team.editTrainee')" :trainee="form" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { mapFields } from 'vuex-map-fields'
import Treeselect from '@riophae/vue-treeselect'
import TraineeForm from '../Profile/my-team/TraineeForm'
export default {
  props: ['trainee'],
  name: 'trainee-settings-modal',
  components: { TraineeForm },
  data() {
    return {
      id: null,
      isModalShowing: false,
      form: {},
    }
  },
  computed: {
    ...mapFields(['cart']),
  },
  mounted() {
    this.locale = document.head.querySelector('meta[name="app-locale"]').content

    this.$bus.$on('trainee-settings-modal.show', (data) => {
      if (!this.$lodash.isEmpty(data.trainee)) {
        // this.populate(data.trainee)
        // this.id = data.trainee.id
        this.form = data.trainee
        $('#traineesModal').modal('show')
        this.isModalShowing = true
      }
    })
    this.$bus.$on('trainee-settings-modal.hide', () => {
      $('#traineesModal').modal('hide')
    })
  },
  methods: {
    editTrainee() {
      let data = {}
      let payload = {}
      payload.firstname = this.form.firstname
      payload.lastname = this.form.lastname
      payload.birthday = this.form.birthday
      payload.email = this.form.email
      payload.gender = this.form.gender
      payload.function = this.form.function
      payload.service = this.form.service || ''
      data.payload = payload
      data.id = this.id
      this.$store
        .dispatch('editTrainee', data)
        .then((response) => {
          this.$bus.$emit('trainees-updated', data)
          this.monitor.type = 'text-success'
          this.monitor.visible = true
          this.monitor.message = this.$t('editedSuccessfully')
          this.closeModal()
        })
        .catch((error) => {
          this.monitor.type = 'text-danger'
          this.monitor.message = this.$t('errors.serverError')
          this.monitor.visible = true
          console.log(error)
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        })
    },
    populate(data) {
      this.form.firstname = data.firstname
      this.form.lastname = data.lastname
      this.form.birthday = data.birthday
      this.form.email = data.email
      this.form.gender = data.gender
      this.form.function = data.function
      this.form.service = data.service === '' ? null : data.service
      this.$refs.observer.reset()
    },
    closeModal() {
      setTimeout(() => {
        this.monitor.visible = false
        this.monitor.message = ''
        $('#traineesModal').modal('hide')
      }, 1000)
    },
  },
}
</script>

<style scoped></style>
